import _createClass from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/inherits.js";
import ImageClick from "../image_click/image_click";
/**
 * 滑动验证码
 */
var TYPE = "WORD_IMAGE_CLICK";
var WordImageClick = /*#__PURE__*/function (_ImageClick) {
  function WordImageClick(divId, styleConfig) {
    var _this;
    _classCallCheck(this, WordImageClick);
    _this = _callSuper(this, WordImageClick, [divId, styleConfig]);
    _this.type = TYPE;
    return _this;
  }
  _inherits(WordImageClick, _ImageClick);
  return _createClass(WordImageClick);
}(ImageClick);
export default WordImageClick;